import { Radio, RadioGroup } from '@/components/ui'
import type { UniqueIdentifier } from '@/pages/events/attendees/types'

interface IdentifyStepProps {
  uniqueIdentifier: UniqueIdentifier
  onChange: (value: UniqueIdentifier) => void
}

export default function IdentifyStep({ uniqueIdentifier, onChange }: IdentifyStepProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
      <div>
        <h3 style={{ fontSize: '16px', fontWeight: 500, color: '#111827', marginBottom: '8px' }}>
          How should we identify existing attendees?
        </h3>
        <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
          Choose how to detect duplicate records during import.
        </p>
      </div>

      <RadioGroup
        value={uniqueIdentifier}
        onChange={(e) => onChange(e.target.value as UniqueIdentifier)}
        style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
      >
        <Radio value="email">
          <div style={{ marginLeft: '8px' }}>
            <span style={{ fontWeight: 500 }}>Email</span>
            <p style={{ fontSize: '14px', color: '#6b7280' }}>
              Match attendees by their email address. This is the recommended option.
            </p>
          </div>
        </Radio>

        <Radio value="attendee_id">
          <div style={{ marginLeft: '8px' }}>
            <span style={{ fontWeight: 500 }}>Attendee ID</span>
            <p style={{ fontSize: '14px', color: '#6b7280' }}>
              Match attendees by their internal ID. Use this for updating existing records.
            </p>
          </div>
        </Radio>

        <Radio value="none">
          <div style={{ marginLeft: '8px' }}>
            <span style={{ fontWeight: 500 }}>No unique identifier</span>
            <p style={{ fontSize: '14px', color: '#6b7280' }}>
              All records will be treated as new attendees. Duplicates may be created.
            </p>
          </div>
        </Radio>
      </RadioGroup>
    </div>
  )
}
